import React from "react";
import { Link } from "react-router-dom";

import chevronImg from "../../images/chevron-right-12.svg";

export default function ChevronLink({ children, to, icon, disabled, onClick }) {
  const isDisabled = disabled ? disabled : false;

  return (
    <Link
      className="ChevronLink"
      to={to}
      disabled={disabled}
      onClick={onClick}
      draggable="false"
      style={{ backgroundImage: "url(" + chevronImg + ")" }}
    >
      <div disabled={isDisabled}>
        <div
          className="action-img"
          style={{
            backgroundImage: "url(" + icon + ")",
          }}
        />
      </div>
      <span disabled={isDisabled}>{children}</span>
    </Link>
  );
}
